import React from 'react'
import Container from '../container/container'
import Started from './Started'

export default function GetStartedSection() {
  return (

    <div className="getStarted">

        <div className="rings ring4"></div>

        <Container>

            <div className="start">

                <Started/>

            </div>

        </Container>

    </div>

  )

}
